import { connect } from 'react-redux';
import { ApiCheck } from './ApiCheck';
import { coreActions } from 'src/redux/core/coreActions';
import { getApisStatus, getRealm } from 'src/redux/core/coreSelectors';
var mapStateToProps = function (state) { return ({
    apisStatus: getApisStatus(state),
    realm: getRealm(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    pingApis: function () { return dispatch(coreActions.pingApiRequested()); },
}); };
export default connect(mapStateToProps, mapDispatchToProps)(ApiCheck);
